import React from 'react'
import styled from 'styled-components'
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { education } from '../../data/constants';
import EducationCard from '../Cards/EducationCard';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 1;
    align-items: center;
    padding: 0px 0px 60px 0px;
    @media (max-width: 960px) {
        padding: 0px;
    }
    @media (max-width: 600px) {
        padding: 0px 0px 24px 0px;
    }
`;

const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 1350px;
    padding: 40px 0px 0px 0px;
    gap: 12px;
    @media (max-width: 960px) {
        flex-direction: column;
        padding: 24px 0px 0px 0px;
    }
    @media (max-width: 600px) {
        padding: 12px 0px 0px 0px;
        gap: 6px;
    }
`;

const Title = styled.div`
font-size: 42px;
text-align: center;
font-weight: 600;
margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
      margin-top: 12px;
      font-size: 32px;
  }
`;

const Desc = styled.div`
    font-size: 18px;
    text-align: center;
    max-width: 600px;
    color: ${({ theme }) => theme.text_secondary};
    @media (max-width: 768px) {
        margin-top: 12px;
        font-size: 16px;
    }
`;

const TimelineSection = styled.div`
    width: 100%;
    max-width: 1000px;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    position: relative;
    .MuiTimeline-root {
        margin: 0 auto;
        padding: 0;
    }
    .MuiTimelineItem-root {
        min-height: 120px;
    }
    .MuiTimelineContent-root {
        display: flex;
        justify-content: flex-end;
        width: 50%;
    }
    @media (max-width: 900px) {
        .MuiTimelineItem-root {
            flex-direction: row !important;
        }
        .MuiTimelineContent-root {
            width: 100%;
            justify-content: flex-end;
            padding-left: 24px;
            padding-right: 0;
        }
        .MuiTimelineSeparator-root {
            margin-left: 0;
            margin-right: auto;
        }
    }
`;

const Education = () => {
    // Use a state to track window width for responsive alternate/right
    const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 900);

    React.useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 900);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <Container id="education">
            <Wrapper>
                <Title>Education</Title>
                <Desc>
                    My education has been a journey of self-discovery and growth. My educational details are as follows.
                </Desc>
                <TimelineSection>
                    <Timeline position={isMobile ? "right" : "alternate"}>
                        {education.map((edu, idx) => (
                            <TimelineItem
                                key={edu.id || idx}
                                position={isMobile ? "right" : (idx % 2 === 0 ? "left" : "right")}
                            >
                                <TimelineSeparator>
                                    <TimelineDot variant="outlined" color="secondary" />
                                    {idx !== education.length - 1 && <TimelineConnector style={{ background: '#854CE6' }} />}
                                </TimelineSeparator>
                                <TimelineContent
                                    sx={{
                                        py: '12px',
                                        px: 2,
                                        display: 'flex',
                                        justifyContent: isMobile ? 'flex-end' : (idx % 2 === 0 ? 'flex-end' : 'flex-start'),
                                        width: { xs: '100%', sm: '50%' },
                                    }}
                                >
                                    <EducationCard education={edu}/>
                                </TimelineContent>
                            </TimelineItem>
                        ))}
                    </Timeline>
                </TimelineSection>
            </Wrapper>
        </Container>
    )
}

export default Education